/**
 * @generated SignedSource<<9b82e025502749d65398a1224a13d8b3>>
 * @relayHash fec3092eee5be8002a509e6d3be00bc6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1ab71c9a12a0be2c8e5d9d99b7deecbd0116bb7ce35f6af9111a2fe2f1177c3c

import type { ConcreteRequest } from 'relay-runtime';
export type preloadOutgoingLinksQuery$variables = {
  contentId: string;
};
export type preloadOutgoingLinksQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly outgoingLinks: {
        readonly externalOutgoingLinks: {
          readonly nodes: ReadonlyArray<{
            readonly url: string | null;
          } | null> | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};
export type preloadOutgoingLinksQuery = {
  response: preloadOutgoingLinksQuery$data;
  variables: preloadOutgoingLinksQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "PaginatedContentListWithChild",
    "kind": "LinkedField",
    "name": "content",
    "plural": false,
    "selections": [
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "concreteType": "OutgoingLinks",
            "kind": "LinkedField",
            "name": "outgoingLinks",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 50
                  }
                ],
                "concreteType": "ConfluenceExternalLinkConnection",
                "kind": "LinkedField",
                "name": "externalOutgoingLinks",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "ConfluenceExternalLink",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "url"
                      }
                    ]
                  }
                ],
                "storageKey": "externalOutgoingLinks(first:50)"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "preloadOutgoingLinksQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "preloadOutgoingLinksQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fec3092eee5be8002a509e6d3be00bc6",
    "id": "1ab71c9a12a0be2c8e5d9d99b7deecbd0116bb7ce35f6af9111a2fe2f1177c3c",
    "metadata": {},
    "name": "preloadOutgoingLinksQuery",
    "operationKind": "query",
    "text": "query preloadOutgoingLinksQuery($contentId:ID!){content(id:$contentId){nodes{id,outgoingLinks{externalOutgoingLinks(first:50){nodes{url}}}}}}"
  }
};
})();

(node as any).hash = "62d400bfa3bd0d225066bef6f6f82860";

export default node;
